import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/113'

const OrdersByClientTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="digital_ordering.tabs.orders_by_client"
  />
)

export default OrdersByClientTab
